export function initNewDisabledItem() {
  return {
    active: false,
  } as any;
}
